import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestSearchResults, requestSearchList } from '../../store/search/search.thunks'
import { setIsAnimatedText, setSearchValues } from '../../store/navigationHeaderMenu/navigationHeaderMenu.slice'
import { setClientWidth } from '../../store/elementsParams/elementsParams.slice'
import { setClientWidthThunk } from '../../store/elementsParams/getElementsParams.thunk'

export const connectSearchDesktop = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      search: state.search,
      searchList: state.search.list,
      menu: state.menu,
      animatedText: state.navigationHeaderMenu.animatedText,
      elementsParams: state.elementsParams,
      clientWidth: state.elementsParams.clientWidth,
      searchValues: state.navigationHeaderMenu.searchValue,
      }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestSearchResults,
      setIsAnimatedText,
      setSearchValues,
      setClientWidth,
      setClientWidthThunk,
      requestSearchList
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
